<template>
    <div class="card-reveal">
        <slot></slot>
    </div>
</template>

<script>
    /**
     * card reveal
     * @module cards/card-reveal
     * @author Jack Yang
     * @description a component for card-reveal
     */
    module.exports = {

    };
</script>


/** WEBPACK FOOTER **
 ** card-reveal.vue?7b12ef1b
 **/